import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue';
import NewModalDialog from '@/components/dialogs/NewModalDialog.vue';
import store from '@/store/store';
import User from '@/model/User';

// const emit = defineEmits(['confirm', 'dismiss']);

export default /*#__PURE__*/_defineComponent({
  __name: 'NewsletterTestEmailRecipientsDialog',
  props: {
  recipients: { type: Array as PropType<{text: string | undefined, value: string}[]>, required: true },
},
  emits: ["confirm", "dismiss"],
  setup(__props, { emit }: { emit: ({(e: 'confirm', recipients: string[]): void
  (e: 'dismiss'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const currentUserEmail = computed(() => {
  const user = store.getters.activeUser as User | undefined;
  return user?.email;
});

const selection = ref([currentUserEmail.value] as string[]);

const sortedRecipients = computed(() => props.recipients.toSorted(
  (a, b) => (a.value === currentUserEmail.value ? -1 : a.value?.localeCompare(b.value)),
));

const selectAll = () => {
  selection.value = selection.value.length === props.recipients.length ? [] : props.recipients?.map((r) => r.value);
};


return { __sfc: true,emit, props, currentUserEmail, selection, sortedRecipients, selectAll, NewModalDialog }
}

})